import React from "react";

import _ from 'lodash';
import cx from 'classnames';

import Content from "../../core/content";
import { ButtonWidget } from "../../button";
import { useWidgetSelector } from "../../core/hooks";

import styles from '../content.module.scss';


const PaginationButtonWidgetComponent = ({ className, style, widgetProps, breakpoint }) => {
  const contentContext = React.useContext(Content.Context);

  const contentGrid = useWidgetSelector(widgetProps.parent);

  const loading = _.get(contentGrid, 'content.mappings.loading');
  const currentPage = _.get(contentGrid, 'content.mappings.pagination.current');
  const totalPages = _.get(contentGrid, 'content.mappings.pagination.totalPages');
  const hasMore = currentPage < totalPages - 1;
  const itemsPerPage = _.get(contentGrid, 'properties.desktop.layoutStyle.itemsPerPage', 2);

  const handleClick = () => {
    const nextPage = currentPage + 1;
    if(nextPage >= totalPages){
      return;
    }

    contentContext.fetchMappingsForContentGrid(contentGrid.uid, nextPage, itemsPerPage);
  }

  if(!hasMore){
    return false;
  }

  return <ButtonWidget
    widgetProps={widgetProps}
    className={cx(className, styles.paginationButton, {
      [style.disabled]: loading
    })}
    key={widgetProps.uid}
    breakpoint={breakpoint}
    style={style}
    onClick={handleClick}
  />
}

const buttonWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'onClick'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const PaginationButtonWidget = React.memo(PaginationButtonWidgetComponent, buttonWidgetEquals);
